<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ item.id ? 'Edit' : 'New' }} industrial property type<br>
                <div class="mt-1">
                  <div class="form-check form-check-success form-switch d-flex align-items-center">
                    <input
                      id="publishContent"
                      v-model="item.active"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="publishContent"
                    ><small class="ms-1">{{ labels['active'] }}</small></label>
                  </div>
                </div>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to programmes list"
              @click="$router.push({name: 'admin.industrial-property-parent-types.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <form
            id="edit-form"
            action=""
          >
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="cart-title">
                    <a data-action="collapse">Content</a>
                  </h3>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li>
                        <a data-action="collapse"><i data-feather="chevron-down" /></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-content collapse show">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.name'] }}</label>
                          <input
                            v-model="item.name"
                            class="form-control"
                            type="text"
                          >
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="mt-1">
                          <div class="form-check form-check-success form-switch d-flex align-items-center">
                            <input
                              id="publishContent"
                              v-model="item.patent_app_number"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              class="form-check-label"
                              for="publishContent"
                            ><small class="ms-1">{{ labels['content.patent_application_number'] }}</small></label>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col-3">
                            <div class="mt-1">
                              <div class="form-check form-check-success form-switch d-flex align-items-center">
                                <input
                                  id="publishContent"
                                  v-model="item.filing_date"
                                  type="checkbox"
                                  class="form-check-input"
                                >
                                <label
                                  class="form-check-label"
                                  for="publishContent"
                                ><small class="ms-1">{{ labels['content.filling_date'] }}</small></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="mt-1">
                              <div class="form-check form-check-success form-switch d-flex align-items-center">
                                <input
                                  id="publishContent"
                                  v-model="item.contract_date"
                                  type="checkbox"
                                  class="form-check-input"
                                >
                                <label
                                  class="form-check-label"
                                  for="publishContent"
                                ><small class="ms-1">{{ labels['content.contract_date'] }}</small></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="mt-1">
                              <div class="form-check form-check-success form-switch d-flex align-items-center">
                                <input
                                  id="publishContent"
                                  v-model="item.licensed_date"
                                  type="checkbox"
                                  class="form-check-input"
                                >
                                <label
                                  class="form-check-label"
                                  for="publishContent"
                                ><small class="ms-1">{{ labels['content.licensed_date'] }}</small></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="mt-1">
                              <div class="form-check form-check-success form-switch d-flex align-items-center">
                                <input
                                  id="publishContent"
                                  v-model="item.sold_date"
                                  type="checkbox"
                                  class="form-check-input"
                                >
                                <label
                                  class="form-check-label"
                                  for="publishContent"
                                ><small class="ms-1">{{ labels['content.sold_date'] }}</small></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="mt-1">
                          <div class="form-check form-check-success form-switch d-flex align-items-center">
                            <input
                              id="publishContent"
                              v-model="item.abandoned_date"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              class="form-check-label"
                              for="publishContent"
                            ><small class="ms-1">{{ labels['content.abandoned_date'] }}</small></label>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="mt-1">
                          <div class="form-check form-check-success form-switch d-flex align-items-center">
                            <input
                              id="publishContent"
                              v-model="item.publication_date"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              class="form-check-label"
                              for="publishContent"
                            ><small class="ms-1">{{ labels['content.publication_date'] }}</small></label>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="mt-1">
                          <div class="form-check form-check-success form-switch d-flex align-items-center">
                            <input
                              id="publishContent"
                              v-model="item.gpg_number"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              class="form-check-label"
                              for="publishContent"
                            ><small class="ms-1">Núm. Secció GPG</small></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>

        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      itemId: this.$route.params.id,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      item: 'industrialPropertyParentTypes/item',
      labels: 'sectionLabels/itemLabels',
    }),
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'masters.industrial_property_type')
    if (this.itemId) {
      await this.$store.dispatch('industrialPropertyParentTypes/fetchId', this.itemId)
    } else {
      await this.$store.dispatch('industrialPropertyParentTypes/cleanType')
    }
  },
  methods: {
    async save() {
      this.sending = true
      try {
        if (this.itemId) {
          await this.$store.dispatch('industrialPropertyParentTypes/update', { id: this.itemId, data: this.item })
        } else {
          await this.$store.dispatch('industrialPropertyParentTypes/create', this.item)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.item.id) {
        Vue.swal('The industrial property parent type has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'admin.industrial-property-parent-types.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
  },

}
</script>
